import { useCanva } from "../context/CanvaContext.jsx";

export default function CanvaCard({ design, draftPrompt = false }) {
  const { exportDesign } = useCanva();

  const id            = design?.id;
  const title         = design?.title || "";
  const thumbnailUrl  = design?.thumbnail?.url || "";
  const editUrl       = design?.urls?.edit_url || "";
  const exportedImage = design?.exported_image;
  const exportedReel  = design?.exported_reel;

  const handleExport = (type) => {
    exportDesign(type, id, draftPrompt);
  };

  return (
    <div className={`image card border-0 animate__animated animate__fadeIn animate__slow canva-design-${id}`}>
      <div className="position-relative">

        <img
          src="/assets/img/864x1080-transparent.png"
          style={{
            background: `url(${thumbnailUrl})`,
            backgroundSize: "cover",
            backgroundPosition: 'top'
          }}
          alt={title || "Canva design"}
          className="img-fluid w-100 rounded-3"
          width="350"
          height="350"
        />


        <div className="position-absolute top-0 start-0 m-1 card-actions z-3">
          <div className="mt-2 px-0 py-1 action-buttons">

            <div className="dropup d-inline-block z-3 position-relative">
              <button
                className="btn text-white"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src="/assets/img/circle-plus.png" width="24" height="24" alt="Import" />
              </button>

              <ul className="dropdown-menu dropdown-menu-end rounded-3">
                {!exportedImage && (
                  <li>
                    <button
                      type="button"
                      className="dropdown-item canva-import-as-image"
                      onClick={() => handleExport("image")}
                    >
                      Import as Image
                    </button>
                  </li>
                )}
                {!exportedReel && (
                  <li>
                    <button
                      type="button"
                      className="dropdown-item canva-import-as-reel"
                      onClick={() => handleExport("reel")}
                    >
                      Import as Reel
                    </button>
                  </li>
                )}
                {exportedImage && exportedReel && (
                  <li>
                    <span className="dropdown-item text-muted">
                      <i className="fi fi-rr-check me-1 text-success" />
                      Already imported
                    </span>
                  </li>
                )}
              </ul>
            </div>

            {editUrl && (
              <a href={editUrl} target="_blank" rel="noreferrer">
                <img
                  src="/assets/img/canva-icon.webp"
                  className="rounded-circle align-bottom ms-1"
                  width="24"
                  alt="Edit in Canva"
                />
              </a>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}